import { parseApiUtcDateTime } from '@core/utils/parseApiUtcDateTime';

export function localTodayIso(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

export function formatRecordedAt(value?: string | null): string {
  const date = parseApiUtcDateTime(value);
  if (!date) return '';
  const datePart = date.toLocaleDateString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const timePart = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).replace(/\s*([AP]M)\s*$/i, (_, marker: string) => ` ${marker.toLowerCase()}`);
  return `${datePart} at ${timePart}`;
}

export function formatShortDateTime(value?: string | null): string {
  const date = parseApiUtcDateTime(value);
  if (!date) return '';
  const day = date.getDate();
  const month = date.toLocaleDateString('en-GB', { month: 'short' });
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${day} ${month} ${date.getFullYear()}, ${time}`;
}

export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined) return '0';
  return value.toLocaleString();
}

export function comparisonLabel(
  comparison: 'up' | 'down' | 'flat' | null | undefined,
  current: number | null | undefined,
  lastMonth: number | null | undefined
): string | null {
  if (comparison == null || current == null || lastMonth == null) return null;
  const delta = current - lastMonth;
  const amount = Math.abs(delta).toLocaleString();
  const signed = delta > 0 ? `+${amount}` : delta < 0 ? `−${amount}` : amount;
  return `${signed} vs current total`;
}

const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** 'YYYY-MM-DD' as '31 Oct 2026'. */
export function formatShortDate(value?: string | null): string {
  if (!value) return '';
  const date = new Date(`${value.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getDate()} ${SHORT_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

/** 'YYYY-MM-DD' minus one day, as 'YYYY-MM-DD'. */
export function dayBeforeIso(value: string): string {
  const date = new Date(`${value.slice(0, 10)}T00:00:00`);
  date.setDate(date.getDate() - 1);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}
